import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const ShipmentCardTopInfo = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing[8],

  ['> img']: {
    borderRadius: 2,
  },
}));

export const ShipmentCardBottomInfo = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',

  '> div': {
    width: '100%',
  },
});

export const ShipmentCardLabel = styled(Typography).attrs({
  variant: TextStyles['Heading 4'],
})(({ theme }) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 2,
  color: theme.colors.highEmphasisBlack,
}));

export const ShipmentCardHeader = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: theme.spacing[8],
}));

export const ShipmentCardTopRight = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const Container = styled.div<{ selected?: boolean; disabled?: boolean }>(({ selected, disabled, theme }) => ({
  width: '100%',
  height: 'fit-content',
  padding: theme.spacing[16],
  borderRadius: 4,
  backgroundColor: theme.colors.highEmphasisWhite,
  wordBreak: 'break-word',
  boxShadow: theme.elevation[2],

  [`${theme.mediaBreakpointUp.lg}`]: {
    cursor: 'pointer',
    filter: 'unset',
    border: `1px solid ${theme.colors.pressedBlack}`,
    transition: '0.3s',
    boxShadow: 'unset',
    ':hover': {
      opacity: 0.8,
    },
    ...(selected && {
      opacity: 1,
      borderColor: theme.colors.blue,
      boxShadow: theme.elevation[2],
      backgroundColor: theme.colors.surface01,
    }),
  },
  ...(disabled && {
    opacity: '0.4 !important',
    ':hover': {
      cursor: 'not-allowed',
      opacity: '0.4 !important',
    },
  }),
}));
